/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  DeleteApiV1SerieSerieidLangsId202,
  DeleteApiV1SerieSerieidLangsId401,
  DeleteApiV1SerieSerieidLangsId404,
  DeleteApiV1SerieSerieidLangsId500,
  DeleteApiV1SerieSerieidLangsIdMutationResponse,
  DeleteApiV1SerieSerieidLangsIdPathParams,
} from "../../types/serieIdiomasController/DeleteApiV1SerieSerieidLangsId.ts";

export const deleteApiV1SerieSerieidLangsIdPathParamsSchema = z.object({
  serieId: z.coerce.number().int(),
  id: z.coerce.number().int(),
}) as unknown as ToZod<DeleteApiV1SerieSerieidLangsIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const deleteApiV1SerieSerieidLangsId202Schema =
  z.any() as unknown as ToZod<DeleteApiV1SerieSerieidLangsId202>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const deleteApiV1SerieSerieidLangsId401Schema =
  z.any() as unknown as ToZod<DeleteApiV1SerieSerieidLangsId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const deleteApiV1SerieSerieidLangsId404Schema =
  z.any() as unknown as ToZod<DeleteApiV1SerieSerieidLangsId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const deleteApiV1SerieSerieidLangsId500Schema =
  z.any() as unknown as ToZod<DeleteApiV1SerieSerieidLangsId500>;

export const deleteApiV1SerieSerieidLangsIdMutationResponseSchema = z.lazy(
  () => deleteApiV1SerieSerieidLangsId202Schema,
) as unknown as ToZod<DeleteApiV1SerieSerieidLangsIdMutationResponse>;
